import React from 'react';

import { Component as LineItemCell } from '../common/LineItemCell.jsx';
import * as ListContainer from '../common/ListContainer.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function LineItems(props) {
    const handleBlockExtras = (props, block) => {
        if (!block || !block.type || !block.type.value) {
            return;
        }
        const blockExtras = { visibility: { ...props.visibility } };
        const hasDiscount = props.data && props.data.HasItemDiscount;
        switch (block.type.value) {
            case Name.Block.Columns:
                if (!hasDiscount) {
                    // TODO can we even do this? need to make sure the 'noDiscount' flag is false too...which can be tricky!
                    // blockExtras.visibility[Token.Inventory.Price] = false;
                    let column, d, done;
                    for (let i = 0; i < block.blocks.length; i++) {
                        column = block.blocks[i];
                        for (let j = 0; j < column.length; j++) {
                            d = column[j];
                            if (d.config && d.config.Block && d.config.Block.design) {
                                const options = Token.extractTokenOptions(Token.Discount, d.config.Block.design);
                                if (options && Utilities.isNullOrWhitespace(options.displayZero)) {
                                    blockExtras.visibility[Token.Discount] = false;
                                    blockExtras.visibility[Token.DisplayCurrency.Discount] = false;
                                    done = true;
                                    break;
                                }
                            }
                        }
                        if (done) {
                            break;
                        }
                    }
                }
                break;
            // Intentional fallthrough
            // case Name.Block.Inventory.Meta:
            //     if (!hasDiscount) {
            //         if (block.config && block.config.Block && block.config.Block.design) {
            //             const options = Token.extractTokenOptions(Token.Discount, block.config.Block.design);
            //             if (!options || Utilities.isNullOrWhitespace(options.displayZero)) {
            //                 blockExtras.visibility[Token.Discount] = false;
            //             }
            //         }
            //         // blockExtras.visibility[Token.Discount] = false;
            //         // const blockExtras = { visibility: { ...props.visibility, [Token.Discount]: false } }
            //     }
            //     break;
            default:
                return;
        }
        return blockExtras
    }
    return <ListContainer.Component cellComponent={LineItemCell} records={Utilities.Inventory.getRecords(props)} onBlockExtras={handleBlockExtras} {...props} />
}

const TypeConfig = {
    panel: {
        block: () => ListContainer.TypeConfig.panel.block(Name.Content.InvoiceLineItem),
        style: ListContainer.TypeConfig.panel.style,
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Signature Placement', name: Token.Inventory.Signature, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Signature, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Dimensions', name: Token.Inventory.AlternateDimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternateDimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Discount', name: Token.Discount, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Discount, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Discount (Display Currency)', name: Token.DisplayCurrency.Discount, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.DisplayCurrency.Discount, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Inventory.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price (Display Currency)', name: Token.DisplayCurrency.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.DisplayCurrency.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Subtotal', name: Token.Total.Subtotal, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Total.Subtotal, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Subtotal (Display Currency)', name: Token.DisplayCurrency.Subtotal, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.DisplayCurrency.Subtotal, config, Name.Block.Inventory.Meta) },
                    { display: 'Quantity', name: Token.Inventory.Quantity, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Quantity, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

export {
    LineItems as Component,
    TypeConfig
}
